import React, { lazy } from 'react';

import { createBrowserRouter } from 'react-router-dom';

const DNISearch = lazy(() => import('@modules/imaging/ImagenMed/DNISearch'));
const DoctorStudies = lazy(() => import('@modules/imaging/ImagenMed/DoctorStudies'));
const DoctorStudiesDetail = lazy(() => import('@modules/imaging/ImagenMed/DoctorStudiesDetail'));
const DoctorStudiesDetailV2 = lazy(
  () => import('@modules/imaging/ImagenMed/detail-v2/DoctorStudiesDetailV2')
);
const StudyViewer = lazy(() => import('@modules/imaging/viewer/StudyViewer/StudyViewer'));
const TermsConditions = lazy(() => import('@/core/TermsConditions/TermsConditions'));
const PrivacyPolicies = lazy(() => import('@/core/TermsConditions/PrivacyPolicies'));

const imagenmedRouter = createBrowserRouter([
  { path: '/', element: <DNISearch /> },
  { path: '/inicio', element: <DNISearch /> },
  { path: '/estudios-doctor', element: <DoctorStudies /> },
  { path: '/estudios-doctor/detail/:id', element: <DoctorStudiesDetailV2 /> },
  // { path: "/estudios-doctor/detail-v2/:id", element: <DoctorStudiesDetailV2 /> },
  { path: '/estudios-medicos/:id', element: <StudyViewer /> },
  { path: '/terminos-y-condiciones', element: <TermsConditions /> },
  { path: '/politicas-de-privacidad', element: <PrivacyPolicies /> },
  // fallback -> search
  { path: '*', element: <DNISearch /> },
]);

export default imagenmedRouter;
